import { RoleBasedProjectRatesService } from "@/services/roleBasedProjectRatesService";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const useProjectRateQuery = () => {
  const params = useParams();
  const rateId = params.rateId as string;

  const query = useQuery({
    queryKey: ["projectRate", rateId],
    queryFn: () => RoleBasedProjectRatesService.get(rateId),
  });

  return query;
};
